import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

const initialState: any = {
  listItems: [],  // users that have credentials configured
  loading: false,
  saveLoading: false,
};

export const getCashCalcCredentialsList = createAsyncThunk(
  "cashcalcCredentials/getList",
  async (_, { rejectWithValue }) => {
    try {
      const response: any = await apiServices.systemManager.cashCalcCredentials.getList();
      const { isError, data } = response.data;
      if (isError || !data) return rejectWithValue("Failed to fetch credentials");
      return Array.isArray(data) ? data : [data];
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const upsertCashCalcCredential = createAsyncThunk(
  "cashcalcCredentials/upsert",
  async ({ userId, data }: { userId: string; data: any }, { rejectWithValue }) => {
    try {
      const response: any = await apiServices.systemManager.cashCalcCredentials.upsert(userId, data);
      if (response.data?.isError) return rejectWithValue(response.data.error?.message || "Failed to save");
      return response.data?.data || response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const deleteCashCalcCredential = createAsyncThunk(
  "cashcalcCredentials/delete",
  async (userId: string, { rejectWithValue }) => {
    try {
      const response: any = await apiServices.systemManager.cashCalcCredentials.delete(userId);
      if (response.data?.isError) return rejectWithValue(response.data.error?.message || "Failed to delete");
      return userId;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const cashcalcCredentialsSlice = createSlice({
  name: "cashcalcCredentials",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCashCalcCredentialsList.pending, (state) => {
        state.loading = true;
        state.listItems = [];
      })
      .addCase(getCashCalcCredentialsList.fulfilled, (state, action) => {
        state.loading = false;
        state.listItems = action.payload;
      })
      .addCase(getCashCalcCredentialsList.rejected, (state) => {
        state.loading = false;
      })
      .addCase(upsertCashCalcCredential.pending, (state) => {
        state.saveLoading = true;
      })
      .addCase(upsertCashCalcCredential.fulfilled, (state, action) => {
        state.saveLoading = false;
        const updated = action.payload;
        const idx = state.listItems.findIndex((i: any) => i.UserId === updated?.UserId);
        if (idx >= 0) {
          state.listItems[idx] = updated;
        } else {
          state.listItems = [...state.listItems, updated];
        }
      })
      .addCase(upsertCashCalcCredential.rejected, (state) => {
        state.saveLoading = false;
      })
      .addCase(deleteCashCalcCredential.fulfilled, (state, action) => {
        state.listItems = state.listItems.filter((i: any) => i.UserId !== action.payload);
      });
  },
});

export default cashcalcCredentialsSlice.reducer;
